/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InventoryControlSelectedItemModel } from './inventoryControlSelectedItemModel';
import { InventoryControlItemModel } from './inventoryControlItemModel';


export interface InventoryControlItemResponseModel { 
    availabelItems?: Array<InventoryControlItemModel> | null;
    selectedItems?: Array<InventoryControlSelectedItemModel> | null;
}

